import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { LoginState } from "./types";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, endpoints, formatErrors } from "utils/api/endpoints";


export const initialState: LoginState = {
  isLoading: false,
  error: null,
  data: null,
};

// RTK Query API for login
export const api = createApi({
  reducerPath: "loginApi",
  baseQuery,
  endpoints: (builder) => ({
    login:  builder.mutation<any, { email: string, password: string }>({
      query: (body) => ({
        url: endpoints.login.url,
        method: endpoints.login.method,
        body: body,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    //  verify otp
verifyOtp: builder.mutation<any, { email: string, code: string }>({
  query: (body) => ({
    url: endpoints.verifyOtpLogin.url,
    method: endpoints.verifyOtpLogin.method,
    body: body,
  }),
}),
//   Resend verification code
resendVerificationCode:builder.mutation<any, { email: string }>({
  query: (body) => ({
    url: endpoints.resendVerificationCode.url,
    method: endpoints.resendVerificationCode.method,
    body: body,
  }),
}),
// forgot password
forgotPassword: builder.mutation<any, { email: string }>({
  query: (body) => ({
    url: endpoints.forgotPassword.url,
    method: endpoints.forgotPassword.method,
    body: body,
  }),
}),
resetPassword: builder.mutation<any, { password: string; token: string }>({
  query: (body) => ({
    url: endpoints.resetPassword.url,
    method: endpoints.resetPassword.method,
    body: body,
  }),
}),
  })
})


const slice = createSlice({
  name: "login",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const { actions: loginActions, reducer: loginReducer } = slice;

export const useReturningSigninSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });

  // RTK Query injects itself
  return {
    actions: slice.actions,
    ...api,
  };  
};

export const { useLoginMutation } = api;

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
